// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__ksVVg","Booking":"NavItem_Booking__HN1ra"};